/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control");

/**
 * @class
 */
UI.Widget.Forms.Control.Container = Class( /** @lends UI.Widget.Forms.Control.Container.prototype */ {
    controls: [],
    $controlsContainer: null,

    $controls: function(selector) {
        return $("control" + selector, this.$controlsContainer);
    },

    eachControl: function(callback) {
        $("control:not([group]):not([control-bind=manual])", this.$controlsContainer).each(function() {
            return callback($(this));
        });

        return this;
    },

    eachControls: function(callback) {
        for (var i = 0; i < this.controls.length; i++) {
            callback(this.controls[i]);

            if (this.controls[i].Is(UI.Widget.Forms.Control.Container)) {
                this.controls[i].eachControls(callback)
            }
        }

        return this;
    },

    controlClass: function($control) {
        var type = $($control).attr("type");

        type = type[0].toUpperCase() + type.substr(1);

        type = type.replace(/-\w/g, function(match) {
            return match.substr(1).toUpperCase();
        });

        return "UI.Widget.Forms.Control." + type;
    },

    createControl: function($control) {
        $control = $($control);
        return Util.create(this.controlClass($control), [this, $control]);
    },

    findControl: function($control, recursive) {
        $control = $($control);
        recursive = Util.coalesce(recursive, true);

        var element = $control[0];
        var control = null;

        for (var i = 0; i < this.controls.length; i++) {
            if (this.controls[i].control == element) {
                control = this.controls[i];
                break;
            } else if (recursive) {
                if (this.controls[i].Is(UI.Widget.Forms.Control.Container)) {
                    if (control = this.controls[i].findControl($control)) {
                        break;
                    }
                }
            }
        }

        return control;
    },

    bindControl: function($control) {
        var self = this;

        if (!$control) {
            this.eachControl(function($control) {
                self.bindControl($control);
            });
        } else {
            var control = this.createControl($control);

            control.bind();
			control.on('update', function (value) {
				this.onControlUpdate(control, value)
			}.bind(this));
			control.on('bind', function (value) {
				this.onControlBind(control, value)
			}.bind(this));
			this.onControlUpdate(control)

            control.once("unbind", function() {
                var index = self.controls.indexOf(control);

                if (~index) {
                    self.controls.splice(index, 1);
                }
            });

            this.controls.push(control);
        }

        return this;
    },

	onControlBind: function (control) {},

	onControlUpdate: function (control, value) {},

    unbindControl: function($control) {
        var self = this;

        if (!$control) {
            this.eachControl(function($control) {
                self.unbindControl($control);
            });
        } else {
            var control = this.findControl($control);

            if (control) {
                control.unbind();
            }
        }

        return this;
    },

    updateControl: function($control) {
        var self = this;

        if (!$control) {
            this.eachControl(function($control) {
                self.updateControl($control);
            });
        } else {
            var control = this.findControl($control);

            if (control) {
                control.update();
            }
        }

        return this;
    },

    rebindControl: function($control, update) {
        update = Util.coalesce(update, true);

        this.unbindControl($control);
        this.bindControl($control);

        if (update) {
            this.updateControl($control);
        }

        return this;
    },

    controlGroupIndex: function(element, group) {
        var $element = $(element);

        if (!group) {
            group = $element.data("group");
        }

        if (!group) {
            return -1;
        }

        var selector = "[control-group=\"" + group + "\"]";
        var $group = $element.parentsUntil(selector).last().parent();

        return $group.parent().children().index($group);
    },

    onControlPreSetValue: function(args) {},

    onControlSetValue: function(args) {}
});
